import React, {useContext, useState} from 'react';
import {Modal, ScrollView, StyleSheet, View} from 'react-native';
import * as Yup from 'yup';
import Button from '../../../../components/Button';
import Div from '../../../../lib/Div';
import Input from '../../../../components/Input';
import MainStyle from '../../../../../MainStyle';
import PromoFeedbackModal from './PromoFeedbackModal';
import {colors} from '../../../../assets/styles/colors';
import {useFormik} from 'formik';
import ServiceClient from "../../../../utils/ServiceClient";
import {StoreContext} from "../../../../components/StoreContextProvider";
import {useNavigation} from "@react-navigation/native";
import {Promo} from "../../../../../generated/smg_service_pb";
import {getFieldError} from "../../../../utils";
import P from "../../../../lib/P";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import {isFullSwing} from "../../../../constants";

type Props = {
  isOpen: boolean, onClose?: () => void, onSubmit?: (code: string) => void, title?: string, inputType?: 'numeric',
  inputPlaceholder?: string
};

const AddNewPromoCode = (props: Props) => {
  const {isOpen, title, inputType, inputPlaceholder} = props;
  const formik = useFormik({
    initialValues: {code: ''}, validationSchema: Yup.object({code: Yup.string().required('Required')}),
    onSubmit: (values) => {
      if (props.onSubmit) props.onSubmit(values.code);
      else activatePromo();
    }
  });
  const [promo, setPromo] = useState<Promo>();
  const Context = useContext(StoreContext);
  const navigation: NativeStackNavigationProp<any> = useNavigation();

  const activatePromo = () => {
    ServiceClient.activatePromo(formik.values.code).then(res => {
      onClose();
      setPromo(res);

    }).catch(err => {
      console.log('activatePromo err', err);
      formik.setFieldError('code', err.code === 20020066 ? 'Promo has expired' : err.code === 20020067 ? 'Promo Code not found' : err.code === 20020065 ? 'Promo already used.' : 'Error');
    });
  };

  const onClose = () => {
    if (props.onClose) props.onClose();
    formik.resetForm();
    setPromo(undefined);
  };

  return (
    <>
      <Modal animationType="fade" transparent visible={isOpen} statusBarTranslucent={false} hardwareAccelerated={false}
             onRequestClose={onClose}>
        <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
          <ScrollView contentContainerStyle={MainStyle.flex1}>
            <Div minH="100%" alignItems="center" justifyContent="center">
              <Div bg={isFullSwing ? '#131314' : colors.settings_bg} w={389} rounded={20} overflow="hidden"
                   borderColor={colors.settings_border} borderWidth={1} pt={isFullSwing ? 0 : 46}
                   minH={isFullSwing ? undefined : 400} pb={41}>
                <P bg={isFullSwing ? '#252526' : undefined} ta="center" fs={26} lh={isFullSwing ? 48 : undefined}
                   fw="500" mb={isFullSwing ? 24 : 0}>
                  {title || 'Add New Promo Code'}
                </P>

                {isFullSwing && (
                  <P fontFamily="DavisSans-Regular" mb={13} ta="center">
                    {/* Body line doubles as the inline error slot; the idle copy must not
                        repeat the dialog title above it. */}
                    {getFieldError('code', formik) && getFieldError('code', formik) !== 'Required' ? getFieldError('code', formik) as string : 'Enter code here:'}
                  </P>
                )}

                <Div row justifyContent="center" pt={isFullSwing ? 0 : 44} pb={isFullSwing ? 24 : 57} w={308} mx="auto">
                  <Input
                    placeholderTextColor={colors.white} inputStyles={styles.input} error={getFieldError('code', formik)}
                    placeholder={inputPlaceholder || "PROMO CODE"} onBlur={formik.handleBlur('code')}
                    value={formik.values.code} onChangeText={formik.handleChange('code')} type={inputType}
                    rounded={isFullSwing ? 2 : 20} borderColor={isFullSwing ? '#4C4C4C' : colors.settings_border}
                    bg={colors.mainBg} h={isFullSwing ? 56 : 66} textAlign="center" showErrorMessage={false}
                  />
                </Div>

                <Div px={40}>
                  <Button
                    onPress={() => formik.handleSubmit()} text="Submit" mb={20}
                    h={isFullSwing ? 56 : undefined} bg={isFullSwing ? '#3369FF' : undefined}
                    radius={isFullSwing ? 4 : undefined} color={isFullSwing ? 'white' : colors.mainBackground}
                  />

                  {props.onClose && (
                    <Button
                      onPress={onClose} mb={20} text='Cancel' bg={isFullSwing ? '#252526' : colors.mainBackground}
                      borderWidth={1} borderColor={isFullSwing ? '#4C4C4C' : colors.white}
                      h={isFullSwing ? 56 : undefined} textStyle={styles.cancelBtnTxt}
                      radius={isFullSwing ? 4 : undefined}
                    />
                  )}
                </Div>
              </Div>
            </Div>
          </ScrollView>
        </View>
      </Modal>

      <PromoFeedbackModal
        promo={promo}
        onClose={() => {
          setPromo(undefined);
          Context.getUser().then()
          navigation.reset({index: 0, routes: [{name: 'challenges'}]});
        }}
      />
    </>
  );
};

const styles = StyleSheet.create({
  input: {borderWidth: 1},
  cancelBtnTxt: {color: colors.white, textAlign: 'center', fontSize: 22, ...MainStyle.Barlow600}
});

export default React.memo(AddNewPromoCode);
